import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { EmptyState as EmptyStateComponent } from '@tribeplatform/react-ui-kit/EmptyState';
import { useI18n } from '../i18n';
export const EmptyState = () => {
    const intl = useI18n();
    return (_jsx(Card, { children: _jsx(Card.Content, { children: _jsx("div", { className: "my-12", children: _jsx(EmptyStateComponent, { title: intl.$t({
                        id: 'Generics.NothingHereYet',
                        defaultMessage: 'Nothing here yet.',
                    }), description: intl.$t({
                        id: 'Feed.EmptyState.Description',
                        defaultMessage: 'Join spaces that you’re interested in or create new posts to enjoy your personalized feed.',
                    }) }, void 0) }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=EmptyState.js.map